module.exports = __webpack_public_path__ + "static/media/gu.33465366.jpeg";